<template>
  <nav class="toolbar">
    <v-app-bar flat height="80" color="darkblue" app class="top-navbar pa-0">
      <v-container class="py-0 px-md-6 fill-height">
        <v-row no-gutters align="center">
          <router-link to="/Home" exact>
            <img src="/assets/images/bw-legal-logo-inverted.svg" width="97px" height="26px" class="logo" alt="BW Legal Logo" />
          </router-link>
          <v-toolbar-title class="ml-1 top-navbar__brand">
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <div class="hidden-md-and-down top-navbar__desktop-actions">
            <v-tabs
              background-color="transparent"
              color="transparent"
              slider-color="transparent"
              hide-slider
              class="top-navbar__tabs"
            >
              <v-tab
                v-for="(item, index) in menuItems"
                :key="index"
                :to="{ name: item.route }"
                exact
                class="top-navbar__tab"
              >
                {{ item.title }}
              </v-tab>
            </v-tabs>
            <v-btn :to="{ name: 'HowCanIPay' }" color="primary" outlined large class="ml-4">
              Make a Payment
            </v-btn>
          </div>
          <v-app-bar-nav-icon dark @click.stop="sidebar = !sidebar" class="hidden-lg-and-up"></v-app-bar-nav-icon>
        </v-row>
      </v-container>
    </v-app-bar>
    <div class="hidden-lg-and-up">
      <v-navigation-drawer
        v-model="sidebar"
        temporary
        height="100%"
        color="darkblue"
        dark
        app>
      <v-list>
          <v-list-item-group color="primary">
            <div v-for="(item, index) in sidebarItems" :key="index">
              <v-list-item
                v-if="item.subLinks.length === 0"
                :to="{ name: item.route }"
                exact
                link>
                <v-list-item-icon>
                  <v-icon>{{ getNavIcon(item.route) }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </v-list-item-group>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn block color="primary" outlined large :to="{ name: 'PaymentPortal' }">
            Make a payment
          </v-btn>
        </div>
      </template>
      </v-navigation-drawer>
    </div>
  </nav>
</template>

<script>
import { navMixin } from '@/mixins/navigationMixin.js';

export default {
  name: 'TopNavBar',
  created () {
    this.menuItems = this.getMenuItems();
    this.sidebarItems = this.getSidebarItems();
  },
  data () {
    return {
      menuItems: [],
      sidebarItems: [],
      serviceMenuItems: [],
      sidebar: null,
    };
  },
  mixins: [navMixin],
  methods: {
    clickToHome(path) {
        if(path === this.$route.path) return
        return this.$router.push(path)
    },
    getMenuItems () {
      let items = [
        this.routes.Home,
        this.routes.NextSteps,
        this.routes.AboutUs,
        this.routes.BusinessSite,
        this.routes.Help
      ];
      return this.routesToArray(items)
    },
    getSidebarItems () {
      let items = [
        this.routes.Home,
        this.routes.NextSteps,
        this.routes.AboutUs,
        this.routes.BusinessSite,
        this.routes.Help,
        this.routes.ContactUs
      ];
      return this.routesToArray(items)
    },
    subLinksContainActiveRoute (subLinks) {
      return subLinks.some(x => x.route === this.activeRoute);
    }
  }
};
</script>

<style scoped>
.top-navbar__brand {
  font-weight: 600;
  color: #fff;
  font-size: 24px;
  font-family: Lato,Arial,Helvetica,sans-serif;
  margin-bottom: 5px;
  text-decoration: none;
}

.top-navbar .v-icon {
  color: var(--v-secondary-lighten4);
}

.top-navbar a {
  text-decoration: none;
  color: #fff;
}

.top-navbar__desktop-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
  white-space: nowrap;
}

.top-navbar__tabs {
  flex: 0 0 auto;
  width: auto;
  min-width: 0;
  align-self: center;
  display: inline-flex;
}

.top-navbar__tabs.v-tabs > .v-tabs-bar {
  background-color: transparent;
}

.top-navbar__tabs .v-tabs-bar,
.top-navbar__tabs .v-slide-group,
.top-navbar__tabs .v-slide-group__wrapper,
.top-navbar__tabs .v-slide-group__content {
  width: auto;
  flex: 0 0 auto;
}

.top-navbar__tabs .v-slide-group__content {
  justify-content: flex-end;
}

.top-navbar__tab.v-tab {
  min-width: auto;
  padding: 0 16px;
  color: #fff !important;
  font-size: 14px;
  font-weight: 500;
}

.top-navbar__tab.v-tab:before,
.top-navbar__tab.v-tab:after {
  opacity: 0 !important;
}

.top-navbar__tab.v-tab--active {
  color: #fff;
}

.top-navbar__tab.v-tab:focus,
.top-navbar__tab.v-tab:focus-visible {
  outline: 2px solid #fff;
  outline-offset: -2px;
  border-radius: 4px;
  z-index: 1;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 28px;
}

.v-list-item__action,
.v-list-item__avatar,
.v-list-item__icon {
  display: inline-flex;
  min-width: 28px;
}

.v-item-group.v-bottom-navigation .v-btn {
  min-width: unset;
}

.v-icon.v-icon {
  width: 24px;
  font-size: 20px;
}

.nav-icon {
  width: 14px !important;
  margin-right: -4px !important;
  margin-left: 8px !important;
}

.logo {
  cursor: pointer;
  vertical-align: middle;
}

</style>
